const utils = {
  resolvePosDomain(alias) {
    return `https://${alias}.mysapogo.com`;
  }
};

export default utils;
